module.exports = __webpack_public_path__ + "img/TNT_Vacature_0-2.a645d85e.webp";